import React, { useEffect, useMemo, useState } from "react";
import MainLayout from "../components/MainLayout";
import OrdersTable from "../components/OrdersTable";
import {
  Grid,
  Box,
  Typography,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
} from "@mui/material";
import EventNoteIcon from "@mui/icons-material/EventNote";
import PendingActionsIcon from "@mui/icons-material/PendingActions";
import FunctionsIcon from "@mui/icons-material/Functions";
import { useDispatch, useSelector } from "react-redux";
import {
  fetchDispatcherOrders,
  mergeOrderUpdate,
} from "../features/ordersSlice";

export default function OrderPage() {
  const dispatch = useDispatch();
  const {
    data: orders,
    loading,
    error,
  } = useSelector((state) => state.orders.dispatcher);

  const [statusFilter, setStatusFilter] = useState("active"); // Default filter type

  useEffect(() => {
    dispatch(fetchDispatcherOrders());
  }, [dispatch]);

  const [highlightedId, setHighlightedId] = useState(null);

  useEffect(() => {
    dispatch(fetchDispatcherOrders());

    const interval = setInterval(() => {
      dispatch(fetchDispatcherOrders());
    }, 5000);

    return () => clearInterval(interval);
  }, [dispatch]);

  // Listen to live updates from backend
  // useEffect(() => {
  //   const eventSource = new EventSource(
  //     `${process.env.REACT_APP_API_BASE_URL}/api/orders/events/`
  //   );

  //   // A dispatcher might receive a newly assigned order
  //   eventSource.addEventListener("new_order", (event) => {
  //     const newOrder = JSON.parse(event.data);

  //     // Only add if this order actually belongs to the dispatcher
  //     if (newOrder.dispatcher) {
  //       dispatch(mergeOrderUpdate(newOrder));
  //       setHighlightedId(newOrder.id);
  //     }
  //   });

  //   // Handle order updates (status, notes, etc.)
  //   eventSource.addEventListener("order_updated", (event) => {
  //     const updatedOrder = JSON.parse(event.data);

  //     dispatch(mergeOrderUpdate(updatedOrder));
  //     setHighlightedId(updatedOrder.id);
  //   });

  //   eventSource.onerror = (err) => {
  //     console.error("SSE error:", err);
  //   };

  //   return () => eventSource.close();
  // }, [dispatch]);

  useEffect(() => {
    if (highlightedId) {
      const timer = setTimeout(() => setHighlightedId(null), 2000);
      return () => clearTimeout(timer);
    }
  }, [highlightedId]);

  // Define statuses to exclude by default
  const excludedStatuses = ["closed", "cancelled", "refunded", "failed"];

  const allStatuses = [
    { value: "all", label: "الكل" },
    { value: "pending_dispatch", label: "غير مستلم بعد" },
    { value: "claimed", label: "تم استلام الطلب" },
    { value: "assigned", label: "تم تعيين مزود" },
    { value: "pending_user_payment", label: "بانتظار دفع العميل" },
    { value: "scheduled", label: "تم جدولة الطلب" },
    { value: "in_progress", label: "قيد التنفيذ" },
    { value: "completed", label: "تم الانتهاء" },
    {
      value: "provider_payment_confirmation_pending",
      label: "تأكيد دفع المزود",
    },
    { value: "awaiting_review", label: "بانتظار المراجعة" },
    { value: "closed", label: "مغلق" },
    { value: "cancelled", label: "ملغى" },
    { value: "refunded", label: "مسترجع" },
    { value: "failed", label: "فشل" },
  ];

  const filteredOrders = useMemo(() => {
    if (!orders) return [];
    if (statusFilter === "all") return orders;
    if (statusFilter === "active")
      return orders.filter((o) => !excludedStatuses.includes(o.status));
    return orders.filter((o) => o.status === statusFilter);
  }, [orders, statusFilter]);

  return (
    <MainLayout>
      <Box
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          mb: 2,
          mt: 2,
        }}
      >
        {/* Status Filter Dropdown */}
        <FormControl sx={{ minWidth: 200 }} size="small">
          <InputLabel id="status-filter-label">تصفية حسب الحالة</InputLabel>
          <Select
            labelId="status-filter-label"
            value={statusFilter}
            label="تصفية حسب الحالة"
            onChange={(e) => setStatusFilter(e.target.value)}
          >
            <MenuItem value="active">الطلبات النشطة (الافتراضي)</MenuItem>
            {allStatuses.map((s) => (
              <MenuItem key={s.value} value={s.value}>
                {s.label}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
      </Box>

      <OrdersTable
        title="طلباتي"
        orders={filteredOrders}
        showDetail={true}
        highlightedId={highlightedId}
      />

      {/* {loading ? (
        <Typography align="center" sx={{ mt: 4 }}>
          جاري تحميل الطلبات...
        </Typography>
      ) : error ? (
        <Typography color="error" align="center" sx={{ mt: 4 }}>
          حدث خطأ أثناء تحميل الطلبات
        </Typography>
      ) : (
        <OrdersTable
          title="طلباتي"
          orders={filteredOrders}
          showDetail={true}
          highlightedId={highlightedId}
        />
      )} */}
    </MainLayout>
  );
}
